import {
  FETCH_DRIVERS_DOCUMENTS_DATA,
  FETCH_DRIVERS_DOCUMENTS_SUCCESS,
  FETCH_DRIVERS_DOCUMENTS_FAILURE,
} from "./actionTypes";

export const fetchDriversDocumentsData = (driverId) => ({
  type: FETCH_DRIVERS_DOCUMENTS_DATA,
  driverId: driverId
});

export const fetchDriversDocumentsSuccess = (data) => ({
  type: FETCH_DRIVERS_DOCUMENTS_SUCCESS,
  payload: data,
});

export const fetchDriversDocumentsFailure = (error) => ({
  type: FETCH_DRIVERS_DOCUMENTS_FAILURE,
  payload: error,
});
